import React, { useMemo } from 'react';
import CustomSelect from './CustomSelect';
import { ALL_UNIVERSITIES, POPULAR_UNIVERSITIES } from './Universities';

const UniversitySelect = ({ value, onChange, styles, ...props }) => {
  const universityOptions = useMemo(
    () => ALL_UNIVERSITIES.map(name => ({ value: name, label: name })),
    []
  );

  const popularOptions = useMemo(
    () => POPULAR_UNIVERSITIES.map(name => ({ value: name, label: name })),
    []
  );

  const noOptionsMessage = ({ inputValue }) => {
    if (!inputValue || inputValue.length === 0) {
      return 'Начните вводить название ВУЗа...';
    }
    if (inputValue.length === 1) {
      return 'Введите 2+ символа для поиска по всем ВУЗам';
    }
    return 'ВУЗ не найден';
  };

  return (
    <CustomSelect
      allOptions={universityOptions}
      popularOptions={popularOptions}
      value={value}
      onChange={onChange}
      placeholder="Начните вводить название ВУЗа..."
      noOptionsMessage={noOptionsMessage}
      styles={styles}
      {...props}
    />
  );
};

export default UniversitySelect;